package com.milta.core.localization.translations.fr

import com.milta.core.localization.WebDashboardStrings

internal val WebDashboard = WebDashboardStrings(
    refreshButtonLabel = "Rafraîchir",
    expandedStopsTitle = "Arrêts",
    stopStatusWaitingLabel = "En attente",
    stopStatusFailedLabel = "Non livré",
)
